import { render } from "./InformationBox.vue?vue&type=template&id=37de48da"
import script from "./InformationBox.vue?vue&type=script&lang=js"
export * from "./InformationBox.vue?vue&type=script&lang=js"

import "./InformationBox.vue?vue&type=style&index=0&id=37de48da&lang=scss"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__